import { createEntityQuery } from '@datorama/akita';
import { compareAsc, getYear, parseISO } from 'date-fns';
import { map } from 'rxjs/operators';
import store from './store';

export const query = createEntityQuery(store, {
   sortBy: (a, b) => {
      if (a.from === b.from) {
         return compareAsc(parseISO(b.to), parseISO(a.to));
      }

      return compareAsc(parseISO(a.from), parseISO(b.from));
   },
});

export const entities$ = query.selectAll();
export const activeEntity$ = query.selectActive();
export const hierarchicalOrganisations$ = query.select((state) => state.hierarchicalOrganisations);
export const isHierarchicalOrganisationsLoading$ = query.select((state) => state.isHierarchicalOrganisationsLoading);
export const entityStatusRecords$ = query.select((state) => state.entityStatusRecords);
export const completionStats$ = query.select((state) => state.completionStats);
export const isCompletionStatsLoading$ = query.select((state) => state.isCompletionStatsLoading);
export const kpiDetailsData$ = query.select((state) => state.kpiDetailsData);
export const isLoadingKpiDetails$ = query.select((state) => state.isLoadingKpiDetails);
export const kpiDefinitions$ = query.select((state) => state.kpiDefinitions);

export const entitiesByYear$ = entities$.pipe(map((data) => groupBy(data, (period) => getYear(parseISO(period.to)))));
export const periodsFrom$ = entities$.pipe(map((data) => Array.from(new Set(data.map((period) => period.from)))));
export const periodsTo$ = entities$.pipe(map((data) => Array.from(new Set(data.map((period) => period.to)))));
export const loading$ = query.selectLoading();

function groupBy<T>(data: T[], keyFn: (_item: T) => number) {
   const result = data.reduce<{ key: number; values: T[] }[]>((all, current) => {
      const group = keyFn(current);
      const existingKey = all.find((existing) => existing.key === group);
      if (!existingKey) {
         all.push({ key: group, values: [current] });
      } else {
         existingKey.values.push(current);
      }
      return all;
   }, []);
   return result;
}
